import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { dataTemplateGetRequest, factTableGetRequest } from "../../../_redux/_actions";

import {
     MainLeftTitle,
     CreateButton,
} from "../../_uiComponents/WrapperComponents";
import CreateDataTemplatesForm from "./forms/CreateDataTemplatesForm";
import { FORM_TYPE_ADD, FORM_TYPE_EDIT } from "../../../_helpers/constants";

export default function EditDataTemplates() {
     const { id } = useParams();
     const actionDispatch = useDispatch();

     useEffect(() => {
          actionDispatch(dataTemplateGetRequest({ id }));
     }, []);

     const { details } = useSelector((state) => {
          return {
               details: state.dataTemplate.details,
          };
     });

     return (
          <>
               <MainLeftTitle title="Update Data Templates"></MainLeftTitle>
               <CreateDataTemplatesForm
                    type={FORM_TYPE_EDIT}
                    initialValues={{
                         id: details.id,
                         name: details.name,
                         dataTemplateId: details.dataTemplateTypeId,
                         active: details.active,
                         labels: details.labels,
                    }}
               />
          </>
     );
}
